import HeaderAnimations from './animations/HeaderAnimations';
import FrontpageHero from './animations/FrontpageHero';
import PageHero from './animations/PageHero';
import AccordionSection from './animations/AccordionSection';
import MobileMenu from './modules/MobileMenu';
import Search from './modules/Search';
import Gallery from './modules/Gallery';
import Modalmultisite from './modules/Modalmultisite';
import HeroLottie from './animations/HeroLottie';
import HistoryTimeline from './animations/HistoryTimeline';
import "./vesselgroupblock/index";
import SmoothScroll from './modules/SmoothScroll';
import Lenis from 'lenis';


class App {
	constructor() {
		this._HeaderAnimations();
		this._FrontpageHero();
		this._PageHero();
		this._MobileMenu();
		this._Search();
		this._Gallery();
		this._HeroLottie();
		this._Modalmultisite();
		this._toggleAllLocations();
		this._createAccordionSections();
		this._createHistoryTimeline();
	}
	_Modalmultisite() {
		this.modalMultisite = new Modalmultisite();
	}
	_HeaderAnimations() {

		const subMenus = document.querySelectorAll('.menu-item-has-children');

		subMenus.forEach((subMenu) => {
			// async function makeSubMenuButtons() {
			// 	let myPromise = new Promise(function (resolve) {
			// 		const linkHasSubmenu = subMenu.querySelector('a');
			// 		const arrowMarkup = `<button class="btn__arrow" title="Åpne submeny"><svg width="15" height="24" viewBox="0 0 15 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			// 						<path d="M0.179932 21.18L9.33993 12L0.179932 2.82L2.99993 0L14.9999 12L2.99993 24L0.179932 21.18Z" fill="#35241b"></path>
			// 					</svg></button>`;
			// 		linkHasSubmenu.insertAdjacentHTML('afterend', arrowMarkup);
			// 	});
			// 	await myPromise;

			// 	console.log(document.querySelector('.btn__arrow'));
			// }
			// makeSubMenuButtons();

			const linkHasSubmenu = subMenu.querySelector('a');
			const arrowMarkup = `<button class="btn__arrow" title="Åpne submeny"><svg width="15" height="24" viewBox="0 0 15 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M0.179932 21.18L9.33993 12L0.179932 2.82L2.99993 0L14.9999 12L2.99993 24L0.179932 21.18Z" fill="#35241b"></path>
								</svg></button>`;
			linkHasSubmenu.insertAdjacentHTML('afterend', arrowMarkup);

			const arrowButton = subMenu.querySelector('.btn__arrow');

			arrowButton.addEventListener('click', (e) => {
				if (!subMenu.classList.contains('active')) {
					subMenu.classList.add('active');
				} else {
					subMenu.classList.remove('active');
				}
			});
		});
	}
	_FrontpageHero() {
		this.FrontpageHero = new FrontpageHero();
	}
	_PageHero() {
		this.PageHero = new PageHero();
	}
	_HeroLottie() {
		const animationContainer = document.querySelector('.hero-lottie-animation');
		const animationContainerMobile = document.querySelector('.hero-lottie-animation-mobile');
		if (animationContainer) {
			this.heroLottie = new HeroLottie(animationContainer);
			this.heroLottieMobile = new HeroLottie(animationContainerMobile);
		}
	}
	_MobileMenu() {
		this.mobileMenu = new MobileMenu();
	}
	_Search() {
		const hasSearch = document.querySelector('.search-toggle');
		if (!hasSearch) return;

		this.search = new Search();
	}
	_Gallery() {
		const hasGallery = document.querySelector('.tada--gallery');
		if (!hasGallery) return;

		this.gallery = new Gallery(hasGallery);
	}
	_toggleAllLocations() {
		const moreLocationsLink = document.getElementById('moreLocationsLink');
		const allLocationsContainer = document.getElementById('allLocationsContainer');

		if (moreLocationsLink && allLocationsContainer) {
			moreLocationsLink.addEventListener('click', (e) => {
				e.preventDefault();
				if (allLocationsContainer.style.display === 'none') {
					allLocationsContainer.style.display = 'block';
					moreLocationsLink.innerHTML = 'Less<br>locations...';
				} else {
					allLocationsContainer.style.display = 'none';
					moreLocationsLink.innerHTML = 'More<br>locations...';
				}
			});
		}
	}
	_createAccordionSections() {
		const accordions = [...document.querySelectorAll('.accordion')];
		if (accordions) {
			accordions.forEach((accordion, index) => new AccordionSection(accordion, index));
		}
	}
	_createHistoryTimeline() {
		this.historyTimeline = new HistoryTimeline();
	}
}

new App();
